import { Component, Input } from '@angular/core';

@Component({
  selector: 'content-tag',
  templateUrl: './content-tag.component.html',
  standalone: false,
})
export class ContentTagComponent {
  @Input() label: string = 'Content Tag';
}
